import { Directive, ElementRef, Renderer } from '@angular/core';

@Directive({
  selector: '[btn-color]'
})
export class BtnColorDirective {

  constructor(
    private el: ElementRef,
    private renderer: Renderer
  ) {
    this.setColor();
  }

  setColor() {
    let button_color = '#ffffff';
    let button_background = '#4e8ef7';

    if (localStorage.getItem('base_data') && localStorage.getItem('base_data') != '') {
      let base_data = JSON.parse(localStorage.getItem('base_data'));
      if (base_data['button_color']) {
        button_color = base_data['button_color'];
      }
      if (base_data['button_background_color']) {
        button_background = base_data['button_background_color'];
      }
    }
    
    this.renderer.setElementStyle(this.el.nativeElement, 'color', button_color);
    this.renderer.setElementStyle(this.el.nativeElement, 'backgroundColor', button_background);
  }
}


// WEBPACK FOOTER //
// ./src/directives/btn-color/btn-color.ts